import { BaseDto } from './base.dto';
import { MenuCategoryDto } from './menuCategory.dto';

export class MenuMenuCategoryDto extends BaseDto {
  menuId: number;
  name?: string;
  menuCategoryId: number;
  sequence: number;
  menuCategory: MenuCategoryDto;
}
